/*
  Shared address helpers — used by checkout and by the account profile
  so both forms validate and format identically.
*/

export const STATES = [
  'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
  'Delhi', 'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand',
  'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur',
  'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab', 'Rajasthan',
  'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura', 'Uttar Pradesh',
  'Uttarakhand', 'West Bengal', 'Andaman & Nicobar Islands', 'Chandigarh',
  'Dadra & Nagar Haveli and Daman & Diu', 'Jammu & Kashmir', 'Ladakh',
  'Lakshadweep', 'Puducherry',
];

export const EMPTY_ADDRESS = {
  house: '',
  street: '',
  landmark: '',
  city: '',
  state: '',
  pincode: '',
};

/* Format the parts into the single label-style string stored on the
   order and shown to the customer. */
export const composeAddress = (a = {}) => {
  const get = (k) => String(a[k] || '').trim();

  const house = get('house');
  const street = get('street');
  const landmark = get('landmark');
  const city = get('city');
  const state = get('state');
  const pincode = get('pincode');

  if (!house && !street && !city) return '';

  const lastLine = [city, state].filter(Boolean).join(', ');

  return [
    house,
    street,
    landmark ? `Near ${landmark}` : null,
    pincode ? `${lastLine} - ${pincode}` : lastLine,
  ]
    .filter(Boolean)
    .join('\n');
};

/* Read the saved address off a profile row into form shape. */
export const addressFromProfile = (profile) => ({
  house: profile?.address_house || '',
  street: profile?.address_street || '',
  landmark: profile?.address_landmark || '',
  city: profile?.address_city || '',
  state: profile?.address_state || '',
  pincode: profile?.address_pincode || '',
});

/* Form shape → the column names on public.users. */
export const addressToColumns = (a) => ({
  address_house: a.house.trim() || null,
  address_street: a.street.trim() || null,
  address_landmark: a.landmark.trim() || null,
  address_city: a.city.trim() || null,
  address_state: a.state || null,
  address_pincode: a.pincode.trim() || null,
});

export const isAddressComplete = (a) =>
  Boolean(
    a &&
      String(a.house || '').trim() &&
      String(a.street || '').trim() &&
      String(a.city || '').trim() &&
      a.state &&
      /^\d{6}$/.test(String(a.pincode || '').trim())
  );

/* Returns an error string, or null when the address is usable. */
export const validateAddress = (a) => {
  if (!String(a.house || '').trim())
    return 'Please enter your flat / house number.';
  if (!String(a.street || '').trim())
    return 'Please enter your street or area.';
  if (!String(a.city || '').trim()) return 'Please enter your city.';
  if (!a.state) return 'Please select your state.';
  if (!/^\d{6}$/.test(String(a.pincode || '').trim()))
    return 'PIN code must be 6 digits.';
  return null;
};
